<template>
  <div class="sms1">
    <div v-if="errors.length > 0" class="errors1">
      <div v-for="(error, key) in errors" :key="key" class="error1">
        {{ error }}
      </div>
    </div>
    <div v-if="finalMessage && !checkSmsInProcess && !wrongCodeMsg">
      <h2 v-if="message1">
        Подписание документов прошло успешно. По окончанию формирования ссылки Вам будет доступен для скачивания пакет подписанных документов, ожидайте.
      </h2>
      <h2 v-if="message2">
        Комплект подписанных документов вы можете скачать по <a :href="documentPackageLink">ссылке</a>.
        Обратитесь к менеджеру банка для оплаты страхового взноса.
      </h2>
    </div>
    <h2 v-if="sent && !finalMessage && !checkSmsInProcess && !wrongCodeMsg">Код отправлен</h2>
    <h2 v-if="checkSmsInProcess">Идёт проверка кода, ожидайте</h2>
    <h2 v-if="documentPackageLoading && !finalMessage">Получение информации о готовности пакета документов, ожидайте</h2>
    <h2 v-if="wrongCodeMsg" style="color: red">Введён неверный код</h2>
    <input
        v-if="!finalMessage"
        class="code1"
        :class="{show1: show, code1_disabled: checkSmsInProcess}"
        :disabled="checkSmsInProcess"
        v-model="code"
        type="text"
        v-mask="'####'"
    >
    <button
        v-if="!sent && !finalMessage && !documentPackageLoading"
        :disabled="!active"
        @click="sendSms"
        class="signSC1"
        :class="{disabled1: !active}"
        type="button"
    >
      Получить код
    </button>
    <button
        v-if="sent && !finalMessage && !documentPackageLoading"
        @click="checkSms"
        :disabled="checkSmsInProcess"
        :class="{disabled1: checkSmsInProcess}"
        class="checkSignSC1"
        type="button"
    >
      Подписать
    </button>
  </div>
</template>

<script>
import {mask} from "vue-the-mask";
import axios from "axios";
import {baseURL} from "@/create/composables/const";

export default {
  name: "SmsComponent",
  props: ["active", "checkboxObject", "qualInvestorObject", "email", "signed"],
  data: () => {
    return {
      sent: false,
      code: "",
      show: false,
      errors: [],
      checkSmsInProcess: false,
      message1: false,
      message2: false,
      wrongCodeMsg: false,
      documentPackageLink: null,
      documentPackageLoading: false,
    };
  },
  computed: {
    finalMessage() {
      return this.message1 || this.message2
    }
  },
  methods: {
    async sendSms() {
      const response = await axios.post(baseURL, {
        ver: 0,
        object: "contract",
        action: "landing_signer_send_sms",
        login: "ybrir",
        slug: this.$route.params.slugID,
      });

      if (response.data.state) {
        this.sent = true;
        this.show = true;
      }
    },
    async checkSms() {
      this.checkSmsInProcess = true;
      this.wrongCodeMsg = false;

      const response = await axios.post(baseURL, {
        ver: 0,
        object: "contract",
        action: "landing_signer_check_sms",
        slug: this.$route.params.slugID,
        login: "ybrir",
        email: this.email,
        sms_code: this.code,
        checkboxObject: this.checkboxObject,
        qualified_investor_checkbox: this.qualInvestorObject
      });

      if (response.data.state === 'success') {
        await this.getPack();
      } else {
        // console.log(`error`);
        this.wrongCodeMsg = true
      }

      this.checkSmsInProcess = false;
    },
    async getPack() {
      try {
        this.documentPackageLoading = true;
        const response2 = await axios.post(baseURL, {
          ver: 0,
          object: "contract",
          action: "landing_signer_main_pack_link",
          slug: this.$route.params.slugID,
          login: "ybrir",
        });

        if (response2.data.state === "success") {
          this.documentPackageLink = response2.data.link;
          this.message2 = true;
          this.message1 = false;
          this.documentPackageLoading = false;
        } else {
          this.message1 = true;
          setTimeout(() => {
            this.getPack();
          }, 10000);
        }
      } catch (e) {
        console.log("Frontend getPack Error - " + e);
      }
    },
    async asyncCreatedHandleSms() {
      await this.getPack();
    },
  },
  created() {
    if (this.signed) {
      // console.log(`SmsComponent signed`);
      this.asyncCreatedHandleSms();
    }
  },
  directives: {mask}
};
</script>

<style scoped>
.sms1 {
  margin-top: 5px;
}

.code1 {
  width: 0;
  transition-duration: 1s;
  opacity: 0;
  margin-left: -23px;
  padding: 10px;
  font: 700 20px SourceSansPro, sans-serif;
  line-height: normal;
  border: 2px solid #005cbf;
  outline: #0075D4;
}

.code1_disabled {
  border: 2px solid #dae0e5;
}

.show1 {
  width: 65px;
  opacity: 1;
  margin-left: 0;
}

.signSC1, .checkSignSC1 {
  padding: 10px;
  background: #0062cc;
  color: #FFFFFF;
  border: 2px solid #005cbf;
  outline: #0075D4;
  cursor: pointer;
  font: 700 20px SourceSansPro, sans-serif;
  line-height: normal;
  border-radius: .3rem;
  width: 250px;
}

.disabled1 {
  color: #212529;
  background-color: #dae0e5;
  border-color: #d3d9df;
  cursor: unset;
}

.error1 {
  font-weight: 700;
  color: rgb(237, 24, 71);
  font-size: 120%;
}

.danger1 {
  border: 2px solid red;
}

h2 a {
  color: #0062cc;
  cursor: pointer;
}

</style>